import _ from "underscore";

function propertyAlias(p) {
  if (p.structure_type === "building" && _.isArray(p.units)) {
    return p.location.x_neighborhood + " " + t("unit");
  } else {
    return p.location.x_neighborhood + " " + structureTypeText(p);
  }
}

function determinePropertyType(p) {
  if (p.price > 0) {
    return "sales";
  } else if (p.rent > 0) {
    return "rent";
  } else if (p.monthly_rate > 0) {
    return "monthly";
  } else if (p.weekly_rate > 0) {
    return "weekly";
  } else {
    return "";
  }
}

function addressText(p) {
  if (
    p.location.prefecture === "東京都" &&
    p.location.neighborhood !== null &&
    p.location.city !== null
  ) {
    return t("short_location", {
      city: p.location.x_city,
      neighborhood: p.location.x_neighborhood,
    });
  } else {
    return p.location.x_city;
  }
}

function roomNumberText(p) {
  return p.room_no
    ? t("unit_no", { room_no: p.room_no })
    : structureTypeText(p);
}

function getSize(p) {
  if (isMembersOnly(p)) {
    return round_down_inc(p.size, 10) + "+";
  } else {
    return p.size;
  }
}

function getCost(p) {
  if (p.rent > 0) {
    return p.rent;
  } else if (p.monthly_rate > 0) {
    return p.monthly_rate;
  } else if (p.weekly_rate > 0) {
    return p.weekly_rate;
  } else if (p.price > 0) {
    return p.price;
  }
  return 0;
}

function isMembersOnly(p) {
  return p.members_only;
}

function structureTypeText(p) {
  switch (p.structure_type) {
    case "unit":
      return t("unit");

    case "house":
      return t("house");

    case "land":
      return t("land");

    case "building":
      return t("building");

    default:
      return p.structure_type;
  }
}

function bedroomNo(p) {
  if (p.bedroom_no === null) {
    return "";
  }

  const floorplan_type = bedroomSuffix(p.bedroom_no, p.floorplan_type);

  return p.bedroom_no === 0
    ? t("studio")
    : t("bedroom_no", { bedroom_no: p.bedroom_no, floorplan_type });
}

function bedroomSuffix(bedroomNo, floorplanType) {
  if (bedroomNo === 0) {
    return "R";
  } else if (floorplanType) {
    return floorplanType;
  } else {
    return "LDK";
  }
}

function bedroomText(p) {
  if (p.bedroom_no === null) {
    return "";
  }

  const floorplan_type = bedroomSuffix(p.bedroom_no, p.floorplan_type);

  return p.bedroom_no === 0
    ? t("studio")
    : t("bedroom_no", { bedroom_no: p.bedroom_no, floorplan_type });
}

function bedroomIcon(p) {
  if (p.bedroom_no === null) {
    return "";
  }

  const floorplan_type = bedroomSuffix(p.bedroom_no, p.floorplan_type);

  return p.bedroom_no === 0
    ? t("studio")
    : t("bedroom_icon", { bedroom_no: p.bedroom_no, floorplan_type });
}

function bathroomIcon(p) {
  if (p.bathroom_no === null) {
    return "";
  }

  return t("bathroom_icon", { bathroom_no: p.bathroom_no });
}

function buildingUrl(p, prefix) {
  if (p.structure_type === "building") {
    return "/" + prefix + "/" + (p.structure_name_slug || "-") + "/";
  } else {
    // Return URL to building page
    return "/" + prefix + "/" + (p.structure_name_slug || "-") + "/";
  }
}

function structureDetailsUrl(p, prefix, key) {
  const basePath = `/${prefix}/${p.structure_name_slug || "-"}/b${p.id}-`;
  const floors = p.structure_type === "land" ? "" : `${p.total_floors}floors-`;
  const size = `${Math.floor(p.size)}sqm-`;
  const type = `${p.structure_type}-`;
  const location = `${p.location.neighborhood_slug}/`;
  const linkKey = key ? `?key=${key}` : "";

  return basePath + floors + size + type + location + linkKey;
}

function unitDetailsUrl(p, unit, prefix, key) {
  // Return unit URL
  return (
    "/" +
    prefix +
    "/" +
    (p.structure_name_slug || "-") +
    "/" +
    unit.id +
    "-" +
    `${unit.bedroom_no}bed` +
    "-" +
    `${unit.bathroom_no}bath` +
    "-" +
    `${Math.floor(unit.size)}sqm` +
    "-" +
    "unit" +
    "-" +
    p.location.neighborhood_slug +
    "/" +
    (key ? "?key=" + key : "")
  );
}

function flatUnitDetailsUrl(p, prefix, key) {
  // Return unit URL
  return (
    "/" +
    prefix +
    "/" +
    (p.structure_name_slug || "-") +
    "/" +
    p.id +
    "-" +
    `${p.bedroom_no}bed` +
    "-" +
    `${p.bathroom_no}bath` +
    "-" +
    `${Math.floor(p.size)}sqm` +
    "-" +
    "unit" +
    "-" +
    p.location.neighborhood_slug +
    "/" +
    (key ? "?key=" + key : "")
  );
}

function cardTitleUrl(p, section, key) {
  let cardTitleUrl = "";

  if (p.structure_type === "house" && p.unit) {
    cardTitleUrl = unitDetailsUrl(p, p.unit, 'properties', key);
  } else if (p.structure_type === "land") {
    cardTitleUrl = structureDetailsUrl(p, 'properties', key);
  } else if (p.structure_type === "building") {
    if (p.units === undefined || p.units.length === 0) {
      cardTitleUrl = structureDetailsUrl(p, 'properties', key);
    } else if (p.units.length === 1) {
      cardTitleUrl = unitDetailsUrl(p, p.units[0], 'properties', key);
    } else {
      cardTitleUrl = buildingUrl(p, 'properties');
    }
  } else {
    cardTitleUrl = buildingUrl(p, 'properties');
  }

  return cardTitleUrl;
}

function getPhotoUrl(p) {
  if (p.image) {
    if (p.structure_type === "unit") {
      // Prepend property ID to filename and return
      return HJ.Config.img_url + "/u/" + p.id + "/" + p.image.filename;
    } else {
      // Prepend building ID to filename and return
      return HJ.Config.img_url + "/b/" + p.id + "/" + p.image.filename;
    }
  } else {
    return null;
  }
}

function getFlatPhotoUrl(p) {
  if (p.image) {
    if (p.structure_type === "unit" || p.structure_type === "house") {
      // Prepend property ID to filename and return
      return HJ.Config.img_url + "/b/" + p.building_id + "/" + p.image.filename;
    } else {
      // Prepend building ID to filename and return
      return HJ.Config.img_url + "/b/" + p.id + "/" + p.image.filename;
    }
  } else {
    return null;
  }
}

function moneyFormat(num, shorten_num = false) {
  if (num === null) {
    return 0;
  }

  let formatted = "";

  // Convert to string
  num = num.toString();

  if (HJ.Config.language === "ja") {
    // If 100万 or more
    if (num >= 1000000) {
      // Divide by 10000, convert to string
      formatted = Math.round(num / 10000).toString();

      // If length is >=5, need to inject 億
      if (formatted.length >= 5) {
        const oku = Number(formatted.slice(0, -4));
        const man = Number(formatted.slice(-4));
        formatted = oku.toString() + "億";
        if (man) {
          formatted += man.toString() + "万";
        }
      } else {
        formatted += "万";
      }
    } else {
      const man = num / 10000;

      // If integer, simply append 万
      if (man % 1 === 0) {
        // JS only has Number type, so need to do (n % 1) to check if integer
        formatted = man + "万";
      }
      // Else, format to 1dp and append 万
      else {
        formatted = man.toFixed(1) + "万";
      }
    }

    return formatted;
  } else {
    if (shorten_num) {
      const maxDigits = num < 1000000000 ? 2 : 3;

      formatted = Number(num).toLocaleString("en-US", {
        maximumFractionDigits: maxDigits,
        notation: "compact",
        compactDisplay: "short",
      });
    } else {
      let pos = 0;
      // Add comma after every 3rd number
      for (let i = num.length; i >= 0; i--) {
        if (3 === pos && i !== 0) {
          formatted = "," + num.charAt(i) + formatted;
          pos = 1;
        } else {
          formatted = num.charAt(i) + formatted;
          pos++;
        }
      }
    }

    return shorten_num
      ? `${currency()} ${formatted}`
      : t("cost", { cost: formatted });
  }
}

function currency() {
  return "&yen;";
}

function trainInfo(p, i) {
  if (p.stations && p.stations[i]) {
    if (isMembersOnly(p)) {
      return p.stations[i].x_station_name;
    } else {
      return t("station_min", {
        station: p.stations[i].x_station_name,
        min: p.stations[i].distance,
      });
    }
  }

  return "";
}

function round_down_inc(value, inc) {
  return Math.floor(value / inc) * inc;
}

function t(key, placeholderList) {
  let translatedText = HJ.translations[key];

  if (translatedText === undefined) {
    console.warn(`Translation for key:"${key}" not found.`);
    return key;
  }

  if (placeholderList) {
    const placeholderKeyList = Object.keys(placeholderList);

    for (const placeholderKey of placeholderKeyList) {
      translatedText = translatedText.replace(
        "${" + placeholderKey + "}",
        placeholderList[placeholderKey],
      );
    }
  }

  return translatedText;
}

export {
  addressText,
  bathroomIcon,
  bedroomIcon,
  bedroomNo,
  bedroomText,
  buildingUrl,
  cardTitleUrl,
  currency,
  determinePropertyType,
  flatUnitDetailsUrl,
  getCost,
  getFlatPhotoUrl,
  getPhotoUrl,
  getSize,
  isMembersOnly,
  moneyFormat,
  propertyAlias,
  roomNumberText,
  round_down_inc,
  structureDetailsUrl,
  structureTypeText,
  t,
  trainInfo,
  unitDetailsUrl,
};
